'use client';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { BoxCTA } from '@lichtblick/photon/atoms/box-cta/box-cta';
import { FieldFooter } from '@lichtblick/photon/atoms/field-footer';
import { ExclamationMarkTriangleXs } from '@lichtblick/photon/icons/symbols/exclamation-mark-triangle-xs';
import { Checkbox } from '@lichtblick/photon/molecules/checkbox';
import { Textfield } from '@lichtblick/photon/molecules/textfield';
import { useTracker } from '@lichtblick/tracker';
import classNames from 'classnames';
import { useParams } from 'next/navigation';
import { useCallback, useState } from 'react';
import { v4 as uuidv4 } from 'uuid';
import { AImage } from '../../AImage/AImage';
import { MTextIntro } from '../../MTextIntro/MTextIntro';
import { MarketingLegalText, marketingLegalText } from './LegalText';
import styles from './lead-form.module.scss';
const REQUEST_ID = uuidv4();
const DEFAULT_REQUIRED_ERROR_MESSAGE = 'Hier fehlt noch eine Angabe';
const EMAIL_PATTERN = String.raw`^([\w.%+\-]+)@([\w\-]+\.)+(\w{2,})$`;
export const LeadForm = ({ dynamicsID, image, keepImageAspectRatio, target, textIntro })=>{
    const { web_campaign_id } = useParams();
    const webCampaignId = Array.isArray(web_campaign_id) ? web_campaign_id[0] : web_campaign_id;
    const [hasSubmitError, setHasSubmitError] = useState(false);
    const [isLoadingMarketingLead, setIsLoadingMarketingLead] = useState(false);
    const { trackCustomEvent } = useTracker();
    const handleError = useCallback(()=>{
        setHasSubmitError(true);
        setIsLoadingMarketingLead(false);
    }, []);
    const onSubmit = useCallback((event)=>{
        event.preventDefault();
        const email = new FormData(event.currentTarget).get('email');
        if (!target.cached_url || !email) {
            return;
        }
        const lead = {
            email: email.toString(),
            contentId: dynamicsID,
            legalText: marketingLegalText,
            requestId: REQUEST_ID,
            target: target.cached_url,
            webCampaignId
        };
        setIsLoadingMarketingLead(true);
        setHasSubmitError(false);
        import('../../../api/lichtblick/graphqlClient').then(({ sdk })=>sdk.eaasCreateMarketingLead({
                input: {
                    lead
                }
            }).then((response)=>{
                if (!response.eaasCreateMarketingLead.isSent) {
                    handleError();
                    return;
                }
                trackCustomEvent({
                    eventName: 'form_submit_solar_ratgeber',
                    customProps: {
                        unique_id: REQUEST_ID,
                        partner: true
                    }
                });
                location.assign('/solar-ratgeber-danke/');
            }).catch(handleError));
    }, [
        dynamicsID,
        target.cached_url,
        webCampaignId,
        trackCustomEvent,
        handleError
    ]);
    return /*#__PURE__*/ _jsxs("section", {
        className: styles.section,
        children: [
            /*#__PURE__*/ _jsx("div", {
                className: styles.col,
                children: image?.[0] && /*#__PURE__*/ _jsx(AImage, {
                    ...image[0],
                    isBackground: !keepImageAspectRatio
                })
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: classNames(styles.col, styles.content),
                children: [
                    textIntro?.[0] && /*#__PURE__*/ _jsx(MTextIntro, {
                        ...textIntro[0]
                    }),
                    /*#__PURE__*/ _jsxs("form", {
                        className: styles.form,
                        onSubmit: onSubmit,
                        children: [
                            /*#__PURE__*/ _jsx(Textfield, {
                                label: "Bitte gib deine E-Mail Adresse ein",
                                name: "email",
                                autoComplete: "email",
                                pattern: EMAIL_PATTERN,
                                required: true,
                                errorMessage: "Bitte gib eine gültige E-Mail-Adresse ein.",
                                type: "email"
                            }),
                            /*#__PURE__*/ _jsx(Checkbox, {
                                "data-testid": "checkbox-optInMarketing",
                                errorMessage: DEFAULT_REQUIRED_ERROR_MESSAGE,
                                label: /*#__PURE__*/ _jsx(MarketingLegalText, {}),
                                children: /*#__PURE__*/ _jsx(Checkbox.Checkbox, {
                                    name: "optInMarketing",
                                    required: true
                                })
                            }),
                            /*#__PURE__*/ _jsx(BoxCTA, {
                                as: "button",
                                disabled: isLoadingMarketingLead,
                                loading: isLoadingMarketingLead,
                                type: "submit",
                                children: "Senden"
                            }),
                            Boolean(hasSubmitError) && /*#__PURE__*/ _jsx(FieldFooter, {
                                error: true,
                                icon: /*#__PURE__*/ _jsx(ExclamationMarkTriangleXs, {}),
                                children: "Beim Senden der Anfrage ist ein unerwarteter Fehler aufgetreten. Bitte versuche es später noch einmal."
                            })
                        ]
                    })
                ]
            })
        ]
    });
};

//# sourceMappingURL=LeadForm.js.map